import React from 'react';

function Quote({ quote }) {
  return (
    <div className="quote">
      <p className="quote-text">"{quote.text}"</p>
      <p className="quote-author">— {quote.author}</p>
    </div>
  );
}

export default Quote;